import { Link } from "react-router-dom";
import { ProductPreview } from "../../components/sections/ProductPreview";

export function Hero() {
  return (
    <section className="hero-section page-view">
      <div className="hero-copy">
        <p className="eyebrow">Premium book PR for serious authors</p>
        <h1>Give your book the launch strategy it deserves.</h1>
        <p className="hero-lede">reviewbub helps authors move beyond scattered promotion with focused publicity campaigns, media outreach, podcast visibility, reader trust signals, and clear reporting from first pitch to final recap.</p>
        <div className="hero-actions"><Link className="primary-action large" to="/packages">View Packages</Link><Link className="secondary-action" to="/demo">Preview Dashboard</Link></div>
        <div className="trust-strip" aria-label="Trust signals"><span>Author-first strategy</span><span>Media-ready positioning</span><span>Weekly campaign reporting</span></div>
      </div>
      <ProductPreview />
    </section>
  );
}
